import { Component } from '@angular/core';
import { Toast, ToastPackage, ToastRef } from 'ngx-toastr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'mail-toast',
  templateUrl: './mail-toast.component.html',
  styleUrls: ['./mail-toast.component.scss']
})
export class MailToastComponent extends Toast {
  constructor(
    protected override toastrService: ToastrService,
    public override toastPackage: ToastPackage,
  ) {
    super(toastrService, toastPackage);
  }

  close(): void {
    this.remove();
  }

  onClickToast(): void {
    this.toastPackage.triggerAction();
    this.remove();
  }
}
